import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { LexicalEditor } from 'lexical';

function RefPlugin({ editorRef }: { editorRef: React.MutableRefObject<LexicalEditor | null> }): null {
    const [editor] = useLexicalComposerContext();
    editorRef.current = editor;
    return null;
}

export default RefPlugin;
